export function restoreValue(input, key) {
  if (!input) return;
  if (input.value) return;

  try {
    const value = window.localStorage.getItem(key);
    if (value !== null) input.value = value;
  } catch {
    // no-op
  }
}

export function persistValue(input, key) {
  if (!input) return;

  input.addEventListener("input", () => {
    try {
      window.localStorage.setItem(key, input.value);
    } catch {
      // no-op
    }
  });
}
